import { render, staticRenderFns } from "./GoalsQuestionView.vue?vue&type=template&id=07c245a0&scoped=true&"
import script from "./GoalsQuestionView.vue?vue&type=script&lang=ts&"
export * from "./GoalsQuestionView.vue?vue&type=script&lang=ts&"
import style0 from "./GoalsQuestionView.vue?vue&type=style&index=0&id=07c245a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c245a0",
  null
  
)

export default component.exports